module.exports = "/assets/ongoing-festivals/banner-mobile.png?ilZYG+G";